export default __webpack_public_path__ + "static/media/LOGO.d8912af8.svg";